<dk-ticker-card
  titleText="Gelir Bütçe Toplam"
  [data]="data"
  [percentage]="14.7"
  contentClass="revenue-total"
></dk-ticker-card>
